import { useLazyLoad } from '@contexts/LazyLoadImageContext'
import type { FetchPriority } from '@components/ResponsiveImage'

export type ImageProps = {
  src: string
  alt?: string
  width?: number
  height?: number
  style?: React.CSSProperties
  onLoad?: () => void
  className?: string
  fetchPriority?: FetchPriority
}

export const Image = ({
  src,
  alt,
  width,
  height,
  style,
  onLoad,
  className,
  fetchPriority = 'auto',
}: ImageProps) => {
  // We lazy load based on the module position on the page
  const lazyLoad = useLazyLoad()

  return (
    <img
      className={className}
      src={src}
      alt={alt}
      loading={lazyLoad ? 'lazy' : 'eager'}
      onLoad={onLoad}
      width={width}
      height={height}
      style={style}
      fetchPriority={fetchPriority}
    />
  )
}
